import {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import { Link } from "react-router-dom";

const pages = [
    {title: 'Home', link: '/'},
    {title: 'About', link: '/about'}, 
    {title: 'Topics', link: '/topics'},
    {title: 'Resources', link: '/resources'},
    {title: 'Contact', link: '/contact'},
    // {title: 'Cards', link: '/cards'}
  ];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static" sx={{backgroundColor: "transparent",boxShadow: 'none', color: 'white', mb: '-3%'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
        {/* <img height="200px" src="MSID LOGO WITH WHITE BORDER.png" alt=""/> */}
          {/* <Box
        component="img"
        sx={{ height: '100%' }}
        alt="Logo"
        src="MSID LOGO WITH WHITE BORDER.png"
      /> */}
      <img height="200px" src="MSID LOGO WITH WHITE BORDER.png" alt=""/>
          <Box sx={{ flexGrow: 0, p: '1%', borderRadius:'10px', display: { xs: 'none', md: 'flex', lg: 'flex' }, textAlign: 'center', backgroundColor: '#35948F', ml: '13%' }}>
            {pages.map((page,key) => (
                <Link to={page.link} key={page.title}>
              <Button
              className="nav-links"
                key={page.title}
                onClick={handleCloseNavMenu}
              >
                {page.title}
              </Button>
              </Link>
            ))}
          </Box>
          <Box sx={{margin: '0 auto', flexGrow: 1, display: { xs: 'flex', md: 'none', lg:'none'}}}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{marginLeft: "80%"}}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' }, textAlign: 'center'
              }}
            >
              {pages.map((page, key) => (
                <MenuItem key={page.title} onClick={handleCloseNavMenu}>
                  <Link to={page.link} key={page.title}><Typography sx={{fontSize: '18px', textAlign: 'center'}}>{page.title}</Typography></Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;